import { useDataQueryContext } from 'modules/dataWarehouse/contexts';
import styled from 'styled-components';
import { DestructiveButton } from 'ui/button';
import { NegativeFill } from 'ui/icons';
import { MODAL_SIZES, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { Body1, colors } from 'ui/theme';
import { useModalContext } from 'utils/contexts/modal';

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.values.quarter};
`;

export const DELETE_SYNC_MODAL_TEXT = {
  bodyText: 'Are you sure you want to delete this sync? This action cannot be undone.',
  buttonId: 'delete-sync-button',
  buttonLabel: 'Delete',
  modalId: 'delete-sync-modal',
};

const { bodyText, buttonId, buttonLabel, modalId } = DELETE_SYNC_MODAL_TEXT;

export const DeleteSyncModal = ({ id }: { id: number | undefined }) => {
  const { hideModal } = useModalContext();
  const { syncs } = useDataQueryContext();

  const currentSync = syncs.find((source) => source.sourceId === id);

  return (
    <>
      {!!currentSync && (
        <Modal id={modalId} isModalOpen={true} onClose={hideModal} size={MODAL_SIZES.MEDIUM}>
          <ModalHeader>
            <StyledHeader>
              <NegativeFill color={colors.iconDestructive} />
              <span>{`Delete ${currentSync.name}`}</span>
            </StyledHeader>
          </ModalHeader>
          <ModalBody>
            <Body1>{bodyText}</Body1>
          </ModalBody>
          <ModalFooter>
            <DestructiveButton data-test={buttonId} onClick={hideModal}>
              {buttonLabel}
            </DestructiveButton>
          </ModalFooter>
        </Modal>
      )}
    </>
  );
};
